// @ts-nocheck
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './Image.module.scss';

const Image = ({
  className,
  fade,
  alt,
  onLoad,
  onError,
  src,
  placeholderSrc,
  ...rest
}) => {
  const [loaded, setLoaded] = useState(false);
  const onLoadOverride = useCallback(
    (...args) => {
      setLoaded(true);
      onLoad(...args);
    },
    [onLoad, setLoaded],
  );

  return (
    <span data-testid="image-span">
      <img
        alt={alt}
        className={classNames(className, {
          [styles.hide]: !loaded,
          [styles.show]: loaded,
          [styles.fade]: fade,
        })}
        onLoad={onLoadOverride}
        onError={onError}
        src={src}
        data-testid="provided-image"
        {...rest}
      />
      {placeholderSrc && (
        <img
          alt={`${alt} placeholder`}
          className={classNames(
            className,
            {
              [styles.hide]: loaded,
              [styles.show]: !loaded,
              [styles.fade]: fade,
            },
            'position-absolute',
          )}
          style={{ left: 0, top: 0 }}
          src={placeholderSrc}
          data-testid="placeholder-image"
          {...rest}
        />
      )}
    </span>
  );
};

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  onLoad: PropTypes.func,
  onError: PropTypes.func,
  fade: PropTypes.bool,
  src: PropTypes.string,
  placeholderSrc: PropTypes.string,
};

Image.defaultProps = {
  className: null,
  onLoad: () => {},
  onError: () => {},
  fade: false,
  src: null,
  placeholderSrc: null,
};

export default Image;
